import api from './api';

/**
 * Servicio de reventa cd-2b (docs/120 F4/F8) para el consultor (Partner Portal): margen propio,
 * simulador de precio, saldo unificado y liquidaciones. Mismo estilo que `cd2bPropuestaService.js`
 * (llamadas directas a `api`, `response.data`). Rutas verificadas contra
 * `api/src/routes/cd2bReventaRoutes.js` (montadas en `/v1/cd2b`).
 *
 * MODO DEMO (igual patrón que `carteraService.js`): un asesor sin certificar no tiene margen ni
 * liquidaciones reales que mostrar — con el toggle activo puede ver cómo SE VERÍA su panel una vez
 * certificado, con datos ficticios que nunca tocan el backend ni dinero real.
 */
const cd2bReventaService = {
  /** Política de margen vigente del asesor autenticado (global + overrides + tope de insignia). */
  async getPolitica() {
    const response = await api.get('/cd2b/margen/politica');
    return response.data;
  },
  /**
   * Guarda cambios en la política. Body: { margenGlobalPct?, overrides?:[{code,tipo,margenPct|margenFijo}] }.
   * El backend responde 400 `TOPE_EXCEDIDO` si algo pide más del tope vigente — no se clampa aquí.
   */
  async putPolitica(data) {
    const response = await api.put('/cd2b/margen/politica', data);
    return response.data;
  },
  /**
   * What-if de precio SIN persistir (para "así se ve tu precio"/confirmar el simulador contra el
   * backend). `politica` es opcional: si se manda, el backend la mezcla sobre la vigente para
   * simular "¿qué pasaría si subo mi margen a X%?" sin guardar nada.
   */
  async simularMargen(payload) {
    const response = await api.post('/cd2b/margen/simular', payload);
    return response.data;
  },
  /** Cartera de liquidaciones (paginada). `filtro.estado` opcional. */
  async listarLiquidaciones(params = {}) {
    const response = await api.get('/cd2b/reventa/liquidaciones', { params });
    return response.data;
  },
  /** Saldo unificado: { comisionPendienteCents, margenPendienteCents, totalPendienteCents }. */
  async getSaldo() {
    const response = await api.get('/cd2b/reventa/saldo');
    return response.data;
  },
  /**
   * Solicita el pago del margen pendiente. El api exige 2FA en esta ruta: si el asesor lo tiene
   * activo, `codigo2fa` viaja en `X-2FA-Token` (sin 2FA activo el api lo deja pasar).
   */
  async solicitarPayout(notes = '', codigo2fa = '') {
    const headers = codigo2fa ? { 'X-2FA-Token': String(codigo2fa).trim() } : undefined;
    const response = await api.post('/cd2b/reventa/payouts', { notes }, headers ? { headers } : undefined);
    return response.data;
  },
};

export default cd2bReventaService;
